"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import c from "../components/Icon/SvgIcon.js";
const e = (t) => /* @__PURE__ */ o(
  c,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.12 16.942c-.956-.318-6.378-1.828-6.696-3.813-.32-1.987 1.674-2.781 1.594-6.117A4.02 4.02 0 0 0 11.992 3a4.02 4.02 0 0 0-4.026 4.012c0 3.337 1.834 4.766 1.595 6.117s-5.74 3.495-6.697 3.813c-.957.317-1.037 2.86-.638 3.972h19.453c.558-1.113.399-3.654-.559-3.972",
        clipRule: "evenodd"
      }
    )
  }
), m = l(e);
export {
  m as AccountAlt,
  m as default
};
